import {create} from "zustand";

const useSelectedWorkspaceStore = create((set) => ({
    selectedWorkspace: null,

    setSelectedWorkspace: (workspace) => set({selectedWorkspace: workspace}),
}));

export default useSelectedWorkspaceStore